import { useEffect, useRef } from "react"

// custom hook that allows us to detect if user clicks outside the target element
// e.g. close the currency dropdown menu when users clicks outside the menu
const useOutsideClick = (callback) => {
  const ref = useRef()

  useEffect(
    () => {
      const handleClick = (e) => {
        if (ref.current && !ref.current.contains(e.target)) {
          callback()
        }
      }

      window.addEventListener("click", handleClick)

      return (_) => window.removeEventListener("click", handleClick)
    },
    // eslint-disable-next-line
    []
  )

  return ref
}

export default useOutsideClick
